import React from 'react';
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import SharingActions from 'actions/sharing/SharingActions';
import SharingFormActions from 'actions/sharing/SharingFormActions';
import FileUploadSharingStore from 'stores/sharing/FileUploadSharingStore';
import DirectCallSharingDialog from 'components/pure/sharing/direct-share/DirectCallSharingDialog';

/**
 * <FileUploadSharingDialogContainer /> connects FileUploadSharingStore to
 * <DirectCallSharingDialog /> so that the latter gets its props updated according
 * to the state of FileUploadSharingStore
 */
class DirectCallSharingDialogContainer extends React.Component {
  static getStores() {
    return [FileUploadSharingStore];
  }

  static getPropsFromStores() {
    const state = FileUploadSharingStore.getState();
    return {
      isSharingFileUploadLoading: state.get('isSharingFileUploadLoading'),
    };
  }

  onClose() {
    SharingActions.closeSharingDialog();
    SharingFormActions.reset();
  }

  render() {
    return (
      <AltContainer>
        <DirectCallSharingDialog {...this.props} onClose={this.onClose} />
      </AltContainer>
    );
  }
}

export default connectToStores(DirectCallSharingDialogContainer);
